function closeAll() {
  document.querySelectorAll(".dropdown-directory").forEach(function (dropdown) {
    var list = dropdown.querySelector(".dropdown-directory__list");
    var btn = dropdown.querySelector(".dropdown-directory__button");
    if (list) list.classList.remove("active");
    if (btn) btn.classList.remove("active");
  });
}

export function dropdownDirectory() {
  document
    .querySelectorAll(".dropdown-directory__button")
    .forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dropdown = button.closest(".dropdown-directory");
        var list = dropdown.querySelector(".dropdown-directory__list");
        var isOpen = list.classList.contains("active");
        closeAll();
        if (!isOpen) {
          list.classList.add("active");
          button.classList.add("active");
        }
      });
    });

  document.addEventListener("click", closeAll);
}
